import { getSchoolYearChoices } from './utils';

const AUTH_ROLES = {
  ADMIN_ROLE: 'admin',
  USER_ROLE: 'master teacher',
};

const USER_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  PENDING: 'pending',
};
const SECTIONS = {
  ADMIN: 'Admin',
  TEACHER: 'Master Teachers',
  STUDENT: 'Student',
};

// Generated rather than hard-coded: the old list ran out at 2030-2031 and had
// to be edited by hand, and every other dropdown kept its own copy that said
// something different. getSchoolYearChoices is the single source now.
const SCHOOL_YEARS = getSchoolYearChoices({ format: 'long' });

// Program Type options for site forms. Values map to the backend `category`
// enum exactly; blank/none clears the field. Task 9 reuses this list.
const SITE_CATEGORIES = [
  { value: 'school pull out', label: 'School Pull Out' },
  { value: 'afterschool', label: 'Afterschool' },
  { value: 'affordable housing', label: 'Affordable Housing' },
];

const ADMIN_USER_GUIDE =
  'https://docs.google.com/document/d/1RptqDXI3-Cv0BQaudzE9ap1WhVBW1ClYItJkxR3spQI/edit#heading=h.i72cuwymd8eb';
const MT_USER_GUIDE =
  'https://docs.google.com/document/d/1MNoU_GbLX8xV2t28pBLt-mbR2XbVwiOENNtLZSSECU0/edit?usp=sharing';

export {
  AUTH_ROLES,
  USER_STATUS,
  SECTIONS,
  SCHOOL_YEARS,
  SITE_CATEGORIES,
  ADMIN_USER_GUIDE,
  MT_USER_GUIDE,
};
